<template>
    <div>
        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="2">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="2" :offset="20">
                    <el-button type="primary" @click="addCollageConfig()" class="header-btn">新建</el-button>
                </el-col>
            </el-row>
        </div>
        <el-row :gutter="20">
            <el-table :data="collageConfigList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading"
                      v-show="!showDialog">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="COLLAGE_ID" label="拼单id" v-show="false"></el-table-column>
                <!--<el-table-column prop="ACTIVE_NAME" label="活动" width="100"></el-table-column>-->
                <el-table-column prop="BEGIN_TIME" label="开始时间" width="100"></el-table-column>
                <el-table-column prop="END_TIME" label="结束时间"></el-table-column>
                <el-table-column prop="NAME" label="拼单名称" width="70"></el-table-column>
                <el-table-column prop="DISCOUNT" label="新人优惠金额" width="70"></el-table-column>
                <el-table-column prop="NUM_HIGH" label="最多人数" width="100" sortable></el-table-column>
                <el-table-column prop="NUM_LOW" label="最少人数" width="80" sortable></el-table-column>
                <el-table-column prop="STARTING_PRICE" label="起步价" width="100" sortable></el-table-column>
                <el-table-column prop="STATUS" label="状态" sortable width="70">
                    <template slot-scope="scope">
                       <img :src="scope.row.BANNER" width="50" />
                    </template>
                </el-table-column>
                <el-table-column prop="STATUS" label="状态" sortable width="70">
                    <template slot-scope="scope">
                        <span>{{scope.row.STATUS == 1 ? '可用' : '不可用'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="PRODUCT_TYPE" label="商品范围" sortable width="70">
                    <template slot-scope="scope">
                        <span>{{scope.row.PRODUCT_TYPE == 1 ? '全部商品' : '自定义商品'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="350">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="editCollageConfig(scope.row)">修改</el-button>
                        <el-button type="primary" size="mini" @click="gotoConfigProduct(scope.row)">拼单商品</el-button>
                        <el-button type="primary" size="mini" @click="gotoConfigDiscount(scope.row)">拼单折扣</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap" v-show="!showDialog">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline.recordsTotal">
                </el-pagination>
            </div>
        </el-row>


        <el-dialog title="拼单商品配置" :visible.sync="showDialog">
            <el-form :model="collageConfigVo" :rules="rules" label-width="120px">
                <el-form-item label="拼单id" v-show="false">
                    <el-input v-model="collageConfigVo.collageId" placeholder="拼单id"></el-input>
                </el-form-item>
                <el-form-item label="拼单名称" prop="name">
                    <el-input v-model="collageConfigVo.name" placeholder="拼单名称"></el-input>
                </el-form-item>
                <el-form-item label="人数范围">
                    <el-input v-model="collageConfigVo.numLow" placeholder="" style="width: 300px;"></el-input>
                    到
                    <el-input v-model="collageConfigVo.numHigh" placeholder="" style="width: 300px;"></el-input>
                </el-form-item>
                <el-form-item label="新人优惠金额" prop="discount">
                    <el-input v-model="collageConfigVo.discount" placeholder="新人优惠金额 0 表示不优惠"></el-input>
                </el-form-item>
                <el-form-item label="拼单起步价" prop="startingPrice">
                    <el-input v-model="collageConfigVo.startingPrice" placeholder="0 表示无成单起步价"></el-input>
                </el-form-item>
                <el-form-item label="拼单图片">
                    <el-upload
                            class="avatar-uploader"
                            :action=uploadUrl
                            :show-file-list="false"
                            :on-success="uploadSuccess"
                            :before-upload="beforeAvatarUpload">
                        <img v-if="collageConfigVo.banner" :src="collageConfigVo.banner" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="开始时间"  prop="beginTime">
                    <el-date-picker
                            v-model="collageConfigVo.beginTime"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择活动开始时间">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="结束时间"  prop="endTime">
                    <el-date-picker
                            v-model="collageConfigVo.endTime"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择活动结束时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="拼单产品">
                    <el-select v-model="collageConfigVo.productType" placeholder="请选择">
                        <el-option
                                v-for="item in productTypeList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!--<el-form-item label="拼单活动" v-show="false">-->
                    <!--<el-select v-model="collageConfigVo.collageDetail.activeNo" filterable clearable placeholder="促销活动">-->
                        <!--<el-option v-for="item in activeList"-->
                                   <!--:key="item.id"-->
                                   <!--:label="item.name"-->
                                   <!--:value="item.id">-->
                        <!--</el-option>-->
                    <!--</el-select>-->
                <!--</el-form-item>-->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showDialog = false">取 消</el-button>
                <el-button type="primary" @click="saveCollageConfig()" class="header-btn">
                    保 存
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        getCollageConfigList,
        uploadCollageConfigBanner,
        saveCollageConfig
    } from '../../api/api';
    export default {
        data() {
            return {
                collageConfigVo:{
                collageId: '',
                name: '',
                activeNo: '',
                numLow: 1,
                numHigh: 50,
                discountType: 1,
                discount: 0,
                productType: 1,
                startingPrice: 0,
                banner:'',
                beginTime:'',
                endTime:""
                },
                listCollageShow: true,//拼单配置列表
                showDialog: false,
                formInline: {
                    platformId: 1,
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },
//                activeList: [],
                collageConfigList: [],
                productTypeList: [{id: 1, name: '全部商品'}, {id: 2, name: '自定义配置商品'}],
                loading: true,
                uploadUrl:uploadCollageConfigBanner,
                rules: {
                    endTime: [
                        { required: true, message: '结束时间必填', trigger: 'blur' }
                    ],
                    startingPrice:[
                        { required: true, message: '开始时间必填', trigger: 'blur' }
                    ],
                    name: [
                        { required: true, message: '请输入活动名称', trigger: 'blur' },
                        { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
                    ],
                    startingPrice:[
                        { required: true, message: '请输入拼单起步价', trigger: 'blur' }
                    ],
                    discount: [
                        { required: true, message: '请输入新人优惠金额', trigger: 'blur' }
                    ]
                }
            }
        },
        created() {
            this.listCollageShow = true;
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getCollageConfigList();
            this.listCollageShow = true;
        },
        methods: {
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg';
                const isLt2M = file.size / 1024 / 1024 < 1;
                if (!isJPG) {
                    this.$message.error('上传头像图片只能是 JPG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 1MB!');
                }
                return isJPG && isLt2M;
            },
            getCollageConfigList() {
                this.loading = true;
                getCollageConfigList(this.formInline).then((res) => {
                    if (res.data.status == 200) {
                        this.loading = false;
                        this.collageConfigList = res.data.value.list.list;
                        this.formInline.recordsTotal = res.data.value.list.total;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            addCollageConfig(){
                this.listCollageShow = false;
                this.showDialog = true;
                this.collageConfigVo={
                    collageId: '',
                        name: '',
                        activeNo: '',
                        numLow: 1,
                        numHigh: 50,
                        discountType: 1,
                        discount: 0,
                        productType: 1,
                        startingPrice: 0,
                        banner:'',
                        beginTime:'',
                        endTime:""
                };
            },
            editCollageConfig(collageConfig){
                this.listCollageShow = false;
                this.showDialog = true;
                this.collageConfigVo.collageId = collageConfig.COLLAGE_ID;
                this.collageConfigVo.name = collageConfig.NAME;
                this.collageConfigVo.numLow = collageConfig.NUM_LOW;
                this.collageConfigVo.activeNo = collageConfig.ACTIVE_NO;
                this.collageConfigVo.numHigh = collageConfig.NUM_HIGH;
                this.collageConfigVo.discount = collageConfig.DISCOUNT;
                this.collageConfigVo.startingPrice = collageConfig.STARTING_PRICE;
                this.collageConfigVo.productType = collageConfig.PRODUCT_TYPE;
                this.collageConfigVo.banner=collageConfig.BANNER;
                this.collageConfigVo.beginTime=collageConfig.BEGIN_TIME;
                this.collageConfigVo.endTime=collageConfig.END_TIME;
            },
            returnHistory(){
                window.history.back()
            },
            handleEdit(collageConfig){
                this.listCollageShow = false;
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getCollageConfigList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getCollageConfigList();
            },
            saveCollageConfig(){
                if(this.collageConfigVo.numLow>=this.collageConfigVo.numHigh){
                    this.$message({
                        message: '人数范围配置有误，请检查',
                        type: 'error'
                    });
                    return;
                }
                saveCollageConfig(this.collageConfigVo).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        this.getCollageConfigList();
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            gotoConfigDiscount(row) {
                //跳转配置拼单折扣
                console.log(row.ACTIVE_NO)
                this.$router.push({path: '/collageDiscount', query: {activeNo: row.ACTIVE_NO, name: row.NAME}})
            },
            //图片上传成功
            uploadSuccess(res) {
                console.log(res);
                if (res.success){
                    this.collageConfigVo.banner=res.value;
                }
            },
            gotoConfigProduct(row) {
                //跳转配置拼单商品
                console.log(row.ACTIVE_NO)
                this.$router.push({
                    path: '/collage/productList',
                    query: {
                        collageId: row.COLLAGE_ID,
                        activeNo: row.ACTIVE_NO,
                        name: row.NAME,
                        productType: row.PRODUCT_TYPE
                    }
                })
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/views/collage/collage.vue